/*
 * Easing Functions - inspired from http://gizma.com/easing/
 * only considering the t value for the range [0, 1] => [0, 1]
 */
export const EasingFunction = {
  // no easing, no acceleration
  linear: (t: number) => t,
  // accelerating from zero velocity
  easeInQuad: (t: number) => t * t,
  // decelerating to zero velocity
  easeOutQuad: (t: number) => t * (2 - t),
  // acceleration until halfway, then deceleration
  easeInOutQuad: (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
  // accelerating from zero velocity
  easeInCubic: (t: number) => t * t * t,
  // decelerating to zero velocity
  easeOutCubic: (t: number) => --t * t * t + 1,
  // acceleration until halfway, then deceleration
  easeInOutCubic: (t: number) =>
    t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  // accelerating from zero velocity
  easeInQuart: (t: number) => t * t * t * t,
  // decelerating to zero velocity
  easeOutQuart: (t: number) => 1 - --t * t * t * t,
  // acceleration until halfway, then deceleration
  easeInOutQuart: (t: number) =>
    t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
  // accelerating from zero velocity
  easeInQuint: (t: number) => t * t * t * t * t,
  // decelerating to zero velocity
  easeOutQuint: (t: number) => 1 + --t * t * t * t * t,
  // acceleration until halfway, then deceleration
  easeInOutQuint: (t: number) =>
    t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t,
};

export enum EasingName {
  linear = 'linear',
  easeInQuad = 'easeInQuad',
  easeOutQuad = 'easeOutQuad',
  easeInOutQuad = 'easeInOutQuad',
  easeInCubic = 'easeInCubic',
  easeOutCubic = 'easeOutCubic',
  easeInOutCubic = 'easeInOutCubic',
  easeInQuart = 'easeInQuart',
  easeOutQuart = 'easeOutQuart',
  easeInOutQuart = 'easeInOutQuart',
  easeInQuint = 'easeInQuint',
  easeOutQuint = 'easeOutQuint',
  easeInOutQuint = 'easeInOutQuint',
}

export function GetEasing(name: string): { (t: number): number } {
  switch (name) {
    case EasingName.linear:
      return EasingFunction.linear;
    case EasingName.easeInQuad:
      return EasingFunction.easeInQuad;
    case EasingName.easeOutQuad:
      return EasingFunction.easeOutQuad;
    case EasingName.easeInOutQuad:
      return EasingFunction.easeInOutQuad;
    case EasingName.easeInCubic:
      return EasingFunction.easeInCubic;
    case EasingName.easeOutCubic:
      return EasingFunction.easeOutCubic;
    case EasingName.easeInOutCubic:
      return EasingFunction.easeInOutCubic;
    case EasingName.easeInQuart:
      return EasingFunction.easeInQuart;
    case EasingName.easeOutQuart:
      return EasingFunction.easeOutQuart;
    case EasingName.easeInOutQuart:
      return EasingFunction.easeInOutQuart;
    case EasingName.easeInQuint:
      return EasingFunction.easeInQuint;
    case EasingName.easeOutQuint:
      return EasingFunction.easeOutQuint;
    case EasingName.easeInOutQuint:
      return EasingFunction.easeInOutQuint;
    default:
      console.warn(
        'Could not find easing function to match',
        name,
        'using linear'
      );
      return EasingFunction.linear;
  }
}
